export enum FunctionalExceptionsType {
  USER_DUPLICATED = 'OktaError',
}
export enum FunctionalExceptionsDesc {
  USER_DUPLICATED = 'User already registered',
}

/* Functional Exceptions */
export const TreatableFunctionalExceptions: any[] = [
  {
    typeError: 'OktaError',
    descError: 'User already registered',
  },
  {
    typeError: 'ParkingCodeNotFoundException',
    descError: 'El código no existe. Por favor, revisa el código introducido.',
  },
  {
    typeError: 'ClaimClinicalProcedureNotFound',
    descError: 'Claim clinical procedure not found',
  },
  {
    typeError: 'Error',
    descError: "Request method 'POST' is not supported",
  },
  {
    typeError: 'RestClientException',
    descError: 'Some exception occurred while binding Teladoc endpoint.',
  },
  {
    typeError: '',
    descError: '',
  },
];
export const FunctionalExceptions: any[] = [
  {
    typeError: 'UserInsuredNumberNotFoundException',
    descError: 'NotExist.registerDto.user',
    errorText: 'back_errors.nouser',
  },
  {
    typeError: 'PolicyNumberNotFoundException',
    descError: 'NotExist.registerDto.policyNumber',
    errorText: 'back_errors.nopolicy',
  },
  {
    typeError: 'UserBirthdateException',
    descError: 'Wrong birth date',
    errorText: 'back_errors.birthdate_incorrect',
  },
  {
    typeError: 'InvalidContactDataException',
    descError: 'Dirección postal no coincide con la dirección postal de facturación.',
    errorText: 'back_errors.wrongaddress',
  },
  {
    typeError: 'UserNotFoundException',
    descError: 'User not found',
    errorText: 'back_errors.nouser',
  },
  {
    typeError: 'UserNotFoundException',
    descError: 'NotExist.registerDto.user',
    errorText: 'back_errors.nouser',
  },
  {
    typeError: 'InvalidContactDataException',
    descError: 'Los dos teléfonos móviles no pueden ser internacionales',
    errorText: 'back_errors.bothinternational',
  },
  {
    typeError: 'InvalidContactDataException',
    descError: 'El correo electrónico secundario es inválido',
    errorText: 'back_errors.secondMail_novalid',
  },
  {
    typeError: 'InvalidContactDataException',
    descError: 'Número de teléfono fijo inválido',
    errorText: 'back_errors.phoneLand_novalid',
  },
  {
    typeError: 'InvalidForgotPasswordToken',
    descError: 'Invalid token',
    errorText: 'back_errors.invalid_token',
  },
  {
    typeError: 'InvalidDocumentNumberException',
    descError: 'Incorrect.forgotPasswordDto.idNumber',
    errorText: 'back_errors.id_number',
  },
  {
    typeError: 'UserBirthdateException',
    descError: 'Birthdate incorrect',
    errorText: 'back_errors.birthdate_incorrect',
  },
  {
    typeError: 'OktaError',
    descError: 'E0000001',
    errorText: 'back_errors.commonpass',
  },
  {
    typeError: 'OktaError',
    descError: 'Wrongprepass',
    errorText: 'back_errors.wrong_prepass',
  },
  {
    typeError: 'OktaError',
    descError: 'RecentlyPassword',
    errorText: 'back_errors.recent_pass',
  },
  {
    typeError: 'OktaError',
    descError: 'CommonlyUsedPassword',
    errorText: 'back_errors.commonpass',
  },
  {
    typeError: 'OktaError',
    descError: 'CurrentPassword',
    errorText: 'back_errors.currentpass',
  },
  {
    typeError: 'AuthorizationRequestInvalid',
    descError: 'MinNumberOfBodyParts: 3',
    errorText: 'back_errors.body_parts_3',
  },
  {
    typeError: 'AuthorizationRequestInvalid',
    descError: 'AttachDocumentNamesDoesNotMatch',
    errorText: 'back_errors.authorization_document_name',
  },
  {
    typeError: 'AuthorizationRequestInvalid',
    descError: 'MedicalReportRequired',
    errorText: 'back_errors.auth_medical_report_required',
  },
  {
    typeError: 'AuthorizationRequestInvalid',
    descError: 'PrescriptionFileNotRequired',
    errorText: 'back_errors.auth_prescription_not_required',
  },
  {
    typeError: 'AuthorizationRequestInvalid',
    descError: 'Invalid Medical Centre',
    errorText: 'back_errors.invalid_centre',
  },
  {
    typeError: 'ReimbursementDraftCreation',
    descError: 'VidalMedicamentNotFound',
    errorText: 'back_errors.vidal_medicament',
  },
  {
    typeError: 'DOCUMENT',
    descError: 'DocumentUploadError',
    errorText: 'back_errors.document_not_valid',
  },
  {
    typeError: 'ReimbursementDraftCreation',
    descError: 'PharmacyAmountNotValid',
    errorText: 'back_errors.pharmacy_amount_notvalid',
  },
  {
    typeError: 'ReimbursementDraftCreation',
    descError: 'MedicamentPriceIncorrect',
    errorText: 'back_errors.vidal_medicament',
  },
  {
    typeError: 'cigna.salud.customer.general.service.service.VidalService',
    descError: 'No unique result',
    errorText: 'back_errors.no_unique_vidal',
  },
  {
    typeError: 'OktaError',
    descError: 'Error genérico',
    errorText: 'back_errors.pass_error',
  },
  {
    typeError: 'UserRegisterAttemtsBlockedException',
    descError: 'register.attempsException.error',
    errorText: 'back_errors.register_attemps',
  },
  {
    typeError: 'UserWithoutPermissionException',
    descError: 'No permission to access insured data',
    errorText: 'back_errors.no_permission',
  },
  {
    typeError: 'MedicalDirectoryError',
    descError: 'Unknow Error - fails to connect with medical directory.',
    errorText: 'back_errors.500',
  },
  {
    typeError: 'BankAccountException',
    descError: 'BankSepaError',
    errorText: 'back_errors.bank_sepa_error',
  },
  {
    typeError: 'BankAccountException',
    descError: 'BankAccountNotValid',
    errorText: 'back_errors.bank_account_not_valid',
  },
  {
    typeError: 'cigna.salud.customer.cita.service.service.CitaService',
    descError: 'ErrorCancelAppointment',
    errorText: 'back_errors.cancelarCita',
  },
  {
    typeError: 'TUOTEMPO',
    descError: 'AppointmentNotFound',
    errorText: 'back_errors.appointmentNotFound',
  },
  {
    typeError: 'TUOTEMPO',
    descError: 'InvalidReservationRequest',
    errorText: 'back_errors.invalidReservationRequest',
  },
  {
    typeError: 'TUOTEMPO',
    descError: 'AppointmentNotReschedulable',
    errorText: 'back_errors.appointmentNotReschedulable',
  },
  {
    typeError: 'TUOTEMPO',
    descError: 'TimeSlotNotAvailable',
    errorText: 'back_errors.timeSlotNotAvailable',
  },
  {
    typeError: 'TUOTEMPO',
    descError: 'ExternalReservationError',
    errorText: 'back_errors.externalReservationError',
  },
  {
    typeError: 'TUOTEMPO',
    descError: 'ExternalRescheduleError',
    errorText: 'back_errors.externalRescheduleError',
  },
  {
    typeError: 'TELADOC',
    descError: 'AppointmentNotReschedulable',
    errorText: 'back_errors.appointmentNotReschedulable',
  },
  {
    typeError: 'TELADOC',
    descError: 'ExternalAttachFileError',
    errorText: 'back_errors.externalAttachFileError',
  },
  {
    typeError: 'TELADOC',
    descError: 'ExternalRescheduleError',
    errorText: 'back_errors.externalRescheduleError',
  },
  {
    typeError: 'TELADOC',
    descError: 'ExternalCreateDependantError',
    errorText: 'back_errors.externalCreateDependantError',
  },
  {
    typeError: 'TELADOC',
    descError: 'AppointmentNotReschedulable',
    errorText: 'back_errors.appointmentNotReschedulable',
  },
  {
    typeError: 'TELADOC',
    descError: 'ExternalCancelError',
    errorText: 'back_errors.cancelarCita',
  },
  {
    typeError: 'TELADOC',
    descError: 'ExternalCancelError',
    errorText: 'back_errors.cancelarCita',
  },
  {
    typeError: 'TELADOC',
    descError: 'ExternalReservationError',
    errorText: 'back_errors.externalReservationError',
  },
  {
    typeError: 'TELADOC',
    descError: 'ExternalUploadsError',
    errorText: 'back_errors.externalReservationError',
  },
  {
    typeError: 'TELADOC',
    descError: 'ExternalStartVideocallError',
    errorText: 'back_errors.externalStartVideocallError',
  },
  {
    typeError: 'TELADOC',
    descError: 'ExternalStopVideocallError',
    errorText: 'back_errors.externalStopVideocallError',
  },
  {
    typeError: 'TELADOC',
    descError: 'ExternalRetrieveDependantsError',
    errorText: 'back_errors.externalRetrieveDependantsError',
  },
  {
    typeError: 'GENERAL',
    descError: 'AppointmentTypeNotFound',
    errorText: 'back_errors.appointmentTypeNotFound',
  },
  {
    typeError: 'GENERAL',
    descError: 'ErrorRetrievingPolicyHolder',
    errorText: 'back_errors.errorRetrievingPolicyHolder',
  },
  {
    typeError: 'EMAIL',
    descError: 'DuplicateEmailError',
    errorText: 'back_errors.errorDuplicateEmail',
  },
  {
    typeError: '',
    descError: '',
    errorText: 'back_errors.',
  },
];

/* System Exceptions */
export const TreatableSystemExceptions: any[] = [
  {
    typeError: 'Error',
    descError: 'jakarta.xml.ws.WebServiceException',
  },
  {
    typeError: '',
    descError: '',
  },
  {
    typeError: '',
    descError: '',
  },
];
export const SystemExceptions: any[] = [
  {
    typeError: 'OktaError',
    descError: 'Wrongprepass',
    errorText: 'back_errors.wrong_prepass',
  },
  {
    typeError: 'OktaError',
    descError: 'RecentlyPassword',
    errorText: 'back_errors.recent_pass',
  },
  {
    typeError: 'OktaError',
    descError: 'CommonlyUsedPassword',
    errorText: 'back_errors.commonpass',
  },
  {
    typeError: 'OktaError',
    descError: 'CurrentPassword',
    errorText: 'back_errors.currentpass',
  },
  {
    typeError: '',
    descError: '',
    errorText: 'back_errors.',
  },
];
